import React, { useState, useRef, useEffect } from 'react';
import QCChecksList from './QCChecksList';
import ViewQCCheck from './ViewQCCheck';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import '../Admin/Users.css';
import { useTranslation } from 'react-i18next';

const QCInspections = () => {
  const { t } = useTranslation('common');
  const [selectedCheckId, setSelectedCheckId] = useState(null);
  const [viewMode, setViewMode] = useState('list');
  const listRef = useRef();
  const viewRef = useRef();

  useEffect(() => {
    updateToolbar(viewMode);
  }, [viewMode, t]);

  const updateToolbar = (mode) => {
    let toolbar = null;

    if (mode === 'list') {
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleNew}>
            <span className="icon">+</span> {t('ui.new')}
          </button>
          <button className="toolbar-btn" onClick={handleRefresh}>
            <span className="icon">↻</span> {t('ui.refresh')}
          </button>
        </>
      );
    } else if (mode === 'create' || mode === 'edit') {
      toolbar = (
        <>
          <button className="toolbar-btn primary" onClick={handleSave}>
            <span className="icon">💾</span> {t('ui.save')}
          </button>
          <button className="toolbar-btn" onClick={handleCancel}>
            <span className="icon">✖</span> {t('ui.cancel')}
          </button>
        </>
      );
    } else {
      toolbar = (
        <>
          <button className="toolbar-btn" onClick={handleEdit}>
            <span className="icon">✏️</span> {t('ui.edit')}
          </button>
          <button className="toolbar-btn danger" onClick={handleDelete}>
            <span className="icon">🗑️</span> {t('ui.delete')}
          </button>
          <button className="toolbar-btn" onClick={handleBack}>
            <span className="icon">⬅️</span> {t('ui.back')}
          </button>
        </>
      );
    }

    if (window.setQCInspectionsToolbar) {
      window.setQCInspectionsToolbar(toolbar);
    }
  };

  const handleSelectCheck = (checkId) => {
    setSelectedCheckId(checkId);
    setViewMode('view');
  };

  const handleBack = () => {
    setSelectedCheckId(null);
    setViewMode('list');
  };

  const handleNew = () => {
    setSelectedCheckId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedCheckId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleSave = () => {
    if (viewRef.current) {
      viewRef.current.handleSave();
    }
  };

  const handleDelete = () => {
    if (viewRef.current) {
      viewRef.current.handleDelete();
    }
  };

  const handleRefresh = () => {
    if (listRef.current) {
      listRef.current.fetchChecks();
    }
  };

  const handleCheckCreated = (checkId) => {
    setSelectedCheckId(checkId);
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchChecks();
    }
  };

  const handleSaveComplete = () => {
    setViewMode('view');
    if (listRef.current) {
      listRef.current.fetchChecks();
    }
  };

  return (
    <div className="departments-page">
      <ResizablePanels
        leftPanel={
          <QCChecksList
            ref={listRef}
            onSelectCheck={handleSelectCheck}
            selectedCheckId={selectedCheckId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewQCCheck
              ref={viewRef}
              checkId={selectedCheckId}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onBack={handleBack}
              onEdit={handleEdit}
              onSave={handleSaveComplete}
              onCancel={handleCancel}
              onCheckCreated={handleCheckCreated}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
};

export default QCInspections;
